import Http from '../api/http';

export default class User extends Http {
  constructor() {
    super();
  }

  /***********用户管理***************/
  /**
   * 查看个人信息
   */
  user_getUserInfoNew() {
    return super.post('user/getUserInfoNew', ...arguments);
  }
  /**
   * 修改用户信息
   * @param {Array} req -  req
   * city (string, optional): 现居城市 ,
   * education (integer, optional): 学历 见枚举 ,
   * headPic (string, optional): 头像地址 ,
   * industry (integer, optional): 行业：见枚举 ,
   * marriage (integer, optional): 婚否 ,
   * nickName (string, optional): 昵称 ,
   * profession (string, optional): 职业 ,
   * salary (integer, optional): 收入水平 见枚举
   */
  user_updateUserInfo() {
    return super.post('user/updateUserInfo', ...arguments);
  }

  /**
   * 个人主页
   */
  user_personalPage() {
    return super.post('user/personalPage', ...arguments);
  }
  /**
   * @description: 查看我的报酬列表
   * @param {type}
   * @return:
   */
  user_myRewardList() {
    return super.post('user/myRewardList', ...arguments);
  }
}
